import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=94fba5e2&scoped=true"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"
import style0 from "./videoList.vue?vue&type=style&index=0&id=94fba5e2&prod&scoped=true&lang=css"
import style1 from "./videoList.vue?vue&type=style&index=1&id=94fba5e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fba5e2",
  null
  
)

export default component.exports